<template>
  <div class="auth-form">
    <div class="auth-form-box">
      <div class="auth-form-head">
        <h1 class="auth-form-title">{{ title }}</h1>
        <div style="font-size: 42px;color: #303133;line-height: 80px;">
          DocAI
        </div>
      </div>
      <div class="auth-form-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthForm',
  props: {
    title: String,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.auth-form {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 100px;

  .auth-form-box {
    width: 330px;
    margin: 0 auto;
    background: #fff;
    border-radius: 6px;

    .auth-form-head {
      margin: 0;
      padding: 25px 15px;
      text-align: center;
      color: #fff;
      position: relative;
    }

    .auth-form-title {
      font-size: 24px;
      color: #fff;
      position: absolute;
      top: -60px;
      left: 0;
      text-align: center;
      width: 100%;
      text-transform: uppercase;
    }
  }

  .auth-form-wrapper::v-deep {
    padding: 20px;
    position: relative;

    input {
      // font-weight: lighter;
      letter-spacing: 1px;
      -webkit-border-radius: 5px;
      border: 1px solid #eaeaec;
      background: #eaeaec;
      box-shadow: none;
      font-size: 12px;
      position: relative;
      height: auto;
      padding: 10px;
      box-sizing: border-box;
      display: block;
      width: 100%;
      line-height: 1.42857143;
      transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

      &::placeholder {
        color: #878d99;
      }
    }

    .el-form-item.is-success {
      .el-input__inner,
      .el-input__inner:focus {
        border-color: #eaeaec;
      }
    }

    .auth-submit {
      width: 100%;

      i {
        font-size: 18px;
        font-weight: bolder;
      }
    }

    .auth-bottom-tip {
      font-size: 12px;
      color: #c7c7c7;
      text-align: center;
      margin-top: 15px;
    }

    .auth-error {
      font-size: 12px;
      color: #fa5555;
      text-align: center;
    }
  }
}
</style>
